import { cx } from 'cva';
import {
  SliderTrack as RACSliderTrack,
  type SliderTrackProps as RACSliderTrackProps,
} from 'react-aria-components/Slider';

import styles from './slider.module.css';

export type SliderTrackProps = RACSliderTrackProps;

export function SliderTrack(props: SliderTrackProps) {
  const { className, ...rest } = props;
  const classes = cx(styles.slider_track, className);
  return <RACSliderTrack className={classes} {...rest} />;
}
